import * as React from 'react';
import { withStyles } from '@material-ui/core';
var styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: 40,
        padding: 120,
        backgroundColor: '#f5f5f5',
        minHeight: 'calc(100vh - 64px)',
    },
    image: {
        paddingTop: 120,
        width: 350,
    },
};
var Maintenance = function (_a) {
    var classes = _a.classes;
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", null, "We're down for maintenance"),
        React.createElement("div", null, "Be right back!"),
        React.createElement("img", { className: classes.image, alt: "Maintenance", src: "assets/images/logos/training-tube.png" })));
};
// @ts-ignore
export default withStyles(styles)(Maintenance);



//////////////////
// WEBPACK FOOTER
// ./src/components/routes/maintenance/index.tsx
// module id = 1811
// module chunks = 81